export default __webpack_public_path__ + "static/media/housingIcon.e43c173c.png";